import {  PolicyContainer } from "../../containers";
import './style.scss'

function Policy() {
    return (
        <div id="policy">
            <PolicyContainer />
        </div>
    );
}
export default Policy;